import SearchInput from "./SearchInput";
import SearchStats from "./SearchStats";
import TagsFilter from "./TagsFilter";
import styles from "./PostsMosaicFilters.module.scss";
import clsx from "clsx";

type Props = {
  className?: string;
  showTagsFilter: boolean;
  showCategoriesFilter: boolean;
};

const PostsMosaicFilters: React.FC<Props> = ({
  className,
  showTagsFilter,
  showCategoriesFilter
}) => {
  return (
    <div
      className={clsx(styles.filters, className)}
      data-content-name="posts-mosaic-filters"
    >
      {showTagsFilter && (
        <TagsFilter
          className={styles.tags}
          attribute="tags.title"
          limit={5}
          data-content-piece="tags-filter"
        />
      )}
      {showCategoriesFilter && (
        <TagsFilter
          className={styles.tags}
          attribute="mainCategory"
          limit={50}
          data-content-piece="categories-filter"
        />
      )}

      <SearchInput
        className={styles.search}
        data-content-piece="search-field"
      />

      <div className={styles.stats}>
        <SearchStats singular="article" plural="articles" />
      </div>
    </div>
  );
};

export default PostsMosaicFilters;
